// extracted by mini-css-extract-plugin
module.exports = {"myorder":"OrderFeedback_style_myorder__1UGA0","myorderTit":"OrderFeedback_style_myorderTit__184Ng","myorderBox":"OrderFeedback_style_myorderBox__1ud0i"};